export default __webpack_public_path__ + "static/media/laundry1-afterA-480w.06419780.png";